export var StoreItemTypeEnum;
(function (StoreItemTypeEnum) {
    StoreItemTypeEnum["ITEM_SET"] = "itemSet";
    StoreItemTypeEnum["STORE_ITEM_GROUP"] = "storeItemGroup";
    StoreItemTypeEnum["CATEGORY"] = "category";
    StoreItemTypeEnum["STORE_ITEM"] = "storeItem";
    StoreItemTypeEnum["ITEM_OPTIONS"] = "itemOptions";
    StoreItemTypeEnum["ITEM_BASE"] = "itemBase";
    StoreItemTypeEnum["ITEM_BASE_GROUP"] = "itemBaseGroup";
    StoreItemTypeEnum["STORE_ITEM_BUNDLE"] = "storeItemBundle";
})(StoreItemTypeEnum || (StoreItemTypeEnum = {}));
//# sourceMappingURL=StoreItemTypeEnum.js.map